import React, {useEffect, useState} from 'react';
import { agent_deep_links } from '../../../service/deep_links';
import {agents as getAgents, agent_permission_lookup} from '../../../service/agents';
import { getCookie } from '../../../utils/shared';

const OfferLinks = ({user_token, set_menu, authorize}) => {

    const [d_view, setDataView] = useState(null);

    let uli_tk = getCookie('agt_usign',true);
    const agent_id = uli_tk["user_id"];

    function newOffer(){
        window.open("https://booking.haystravel.co.uk?agt_token=" + user_token + "&agtusr=" + agent_id, "_blank");
    }

    function copyUrl(url){
        navigator.clipboard.writeText(url);
        alert("It's in your clipboard")
    }

    useEffect(() =>{

        const ini = async() => {

                let uli_tk = getCookie('agt_usign',true);

                const agent_id = uli_tk["user_id"];

                let f = "id absolute_url relative_url created agent_id adults children duration arrival departing price notes accommodation { name resort { name regions { name destinations { name } } } } ";

                const lnks = [{'url': '/', 'name': 'Home'}]
                
                set_menu(lnks)

                let x = agent_deep_links(f, user_token).then((r) =>{
                    if(r == null){
                        return
                    }	
                    if(r.errors != null){
                            if(r.errors.length > 0){
                                alert(r.errors[0].message)
                                return
                            }
                            alert("Unexpected Error Contact HWT support...")
                            return
                    }
                    if(r.agent_deep_links.error != null){
                        alert(r.agent_deep_links.error.result.message)
                        return
                    }
                    setDataView(r.agent_deep_links.result)
                }
                );
        }

        ini();


    }, [])

    const remove = async (id) => {
        if (window.confirm("This will delete the offer, are you sure?") === false) {
            return
        }
    }

    let filter_agt_ops = null;

    let tbl_view = null;
    if(d_view != null){

        // if(d_view.length == 0){
        //     return (<div>
        //         <div className='nothing_here'>
        //         <p>Nothing to see here <br></br>
        //            It looks like you have no promotional codes setup. Click <a href='/promo/add'>here</a> to create a one.</p>
        //         </div>
        //     </div>)
        // }

        let rows = []
        for(let x of d_view){

            let dtype = '';
            if(x.type == 0){
                dtype = '£'
            }
            else{
                dtype = '%'
            }


            rows.push(<tr>
                <td>
                    {x.absolute_url}
                </td>
                <td>
                    {x.accommodation.name} ({x.accommodation.resort.regions[0].destinations[0].name},{x.accommodation.resort.regions[0].name},{x.accommodation.resort.name})
                </td>
                <td>
                    {x.adults}
                </td>
                <td>
                    {x.children}
                </td>
                <td>
                    {x.duration}
                </td>
                <td>
                    {x.arrival}
                </td>
                <td>
                    {x.departing}
                </td>
                <td>
                    {x.price}
                </td>
                <td>
                    {x.notes}
                </td>
                <td>
                    <a style={{cursor:"pointer", textDecoration:'underline', color:'red'}} onClick={() => copyUrl(x.absolute_url)}>Copy Link</a>
                </td>
                {/* <td>
                    <a style={{cursor:"pointer", textDecoration:'underline', color:'red'}} onClick={() => remove(x.id)}>Remove</a>
                </td> */}
            </tr>)
        }

        tbl_view = <table>
                <thead>
                    <td>
                        Share-Link 
                    </td>
                    <td>
                        accommodation 
                    </td>
                    <td>
                        Adults 
                    </td>
                    <td>
                        Children 
                    </td>
                    <td>
                        Duration 
                    </td>
                    <td>
                        Arrival 
                    </td>
                    <td>
                        Departing 
                    </td>
                    <td>
                        Price 
                    </td>
                    <td>
                        Notes 
                    </td>
                    <td></td> 
             
                </thead>
            <tbody>
                {rows}
            </tbody>
        </table>
    }



    return(
        <div>
                <div className='fitler_sec'>
                    {filter_agt_ops}
                    <div className='filter_field'>
                        <div>
                            <button onClick={() => newOffer()}>Share new offer</button>
                        </div>
                    </div>
                </div>
                <div className='rule_tbl'>
                    {tbl_view}
                </div>
        </div>
);


};

export default OfferLinks;
